import React, {Component} from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import 'bootstrap/dist/css/bootstrap.css';
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import paginationFactory from 'react-bootstrap-table2-paginator';


const columns = [{
  dataField: 'locationTitle',
  text: 'Nome attività',
  formatter: (cell, row) => {
    if(row.locationURL=='#')
      return (cell);
    else
      return (<a href={row.locationURL} target="_blank">{row.locationTitle}</a>);//
  },
  filter: textFilter({
        placeholder: 'Cerca nome',
        delay: 0
      })
  },
  {
  dataField: 'locationType',
  text: 'Tipo',
  filter: textFilter({
      placeholder: 'Cerca tipo',
      delay: 0
    })
  },
  {
  dataField: 'locationAddress',
  text: 'Indirizzo',
  filter: textFilter({
      placeholder: 'Cerca indirizzo',
      delay: 0
    })
  },
  {
  dataField: 'locationNote',
  text: 'Note',
  filter: textFilter({
        placeholder: 'Cerca note',
        delay: 0
      })
  },
  {
  dataField: 'locationTel',
  text: 'Contatti',
  formatter: (cell, row) => {
    return (<div>{row.locationTel}<br />{row.locationMail}</div>);//
  },
  filter: textFilter({
      placeholder: 'Cerca',
      delay: 0
    })
  }

];

export default class App extends Component{
  render() {
  return (
  <div>
    <div>
      <br /><br /><br /><br />
      <BootstrapTable
      keyField="id"
      data={ this.state.places }
      columns={ columns }
      filter={filterFactory()}
      pagination={ paginationFactory() }
      striped
      />
    </div>
  </div>)
  }
  state = {
  places: []
  };
  componentDidMount() {
    fetch('https://bresciadomicilio.herokuapp.com/places')
    .then(res => res.json())
    .then((data) => {
      this.setState({ places: data })
  })
  .catch(console.log)
  }
}